import React from 'react';
import windspeedicon from '../../assets/Windspeed.png';

interface WindSpeedDisplayProps {
  windspeed: string;
}

const WindSpeedDisplay: React.FC<WindSpeedDisplayProps> = ({ windspeed }) => {
  const formattedSpeed = (val: any) => {
    const num = Number(val);
    if (isNaN(num)) return "-"; // handles "-", null, undefined, etc.
    return num < 0 ? `${Math.abs(num).toFixed(2)}` : `${num.toFixed(2)}`;
  };

  return (
    <div className="flex items-center gap-3 justify-center mt-4">
      <img src={windspeedicon} alt="Wind Speed Icon" className="w-3 h-3" />
      {/* Call the function with windspeed */}
      <h1 className="text-4xl text-gray-800">{formattedSpeed(windspeed)}</h1>
      <span className="text-xs text-gray-600">MPS</span>
    </div>
  );
};

export default WindSpeedDisplay;
